<template>
    <div class="date-container">
        <i class="bi bi-calendar2 calender" v-if="!selectedDate" @click="openCalendar"></i>
        <i class="bi bi-x-circle calender" v-else @click="handleClearDate"></i>
        <datepicker class="date-input" ref="dateMask" v-model="selectedDate" :typeable="true" placeholder="dd-mm-yyyy"
            inputFormat="dd-MM-yyyy" />
    </div>
</template>
<script>
import Datepicker from 'vue3-datepicker/src/datepicker/Datepicker.vue'

export default {
    components: { Datepicker },
    props: {
        dateType: String,
    },
    data() {
        return {
            selectedDate: ''
        }
    },
    watch: {
        selectedDate(newValue, oldValue) {
            const selectedDate = newValue ? `${newValue.getFullYear()}-${String(newValue.getMonth() + 1).padStart(2, '0')}-${String(newValue.getDate()).padStart(2, '0')}` : null;
            this.$emit('getDate', selectedDate);
        },
    },
    methods: {
        handleClearDate() {
            this.selectedDate = ''
        },

        openCalendar() {
            // const v = { ...this.$refs.dateMask }
            // v.renderView('day')
            this.$refs.dateMask.renderView('day')
        }
    }
}
</script>

<style lang="scss">
@import "@/public/scss/common/filter/date.scss";
</style>